module.exports = __webpack_public_path__ + "img/s118a_thumb.f5730cac.jpg";